import {appendPaginationQueryParamsToUrl, post} from '../utils'

const url = (host, rename, options) => appendPaginationQueryParamsToUrl(`${host}/contentCreations/renameMasively?name_prefix=${rename}`, {...options, alreadyHasQueryParams: true});

export default host => (rename, options) =>
  post(url(host, rename, options))
